<app-welcome-view />

<app-say-good-bye-view />

<div class="home__container">
  <header class="home__header">
    @if (checkIsBackButtonVisible()) {
      <ci-icon-button 
        class="header__back-button"
        type="tonal" 
        name="previous"
        (click)="goBack()"
      ></ci-icon-button>
    }
    <img 
      class="home__logo" 
      src="/assets/fitur-2026/imgs/cicerone-logo.svg"
    >
  </header>
  
  <main class="home__main">
    <section class="home__router">
      <router-outlet />
    </section>
  
    <aside class="home__aside-chatbot">
      <app-box-1 [borderRadius]="32">
        @if(chatId()){
          <app-chatbot 
            class="home__chatbot"
            [chatID]="chatId()"
          />
        }
      </app-box-1>
    </aside>
  </main>
</div>

<!--@if (routeToken()) {
  <app-custom-route [routeToken]="routeToken()" />
}-->